import $ from 'cash-dom';

function updateScrollHint(el) {
	const canScroll = el.scrollWidth > el.clientWidth + 1;
	const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

	el.classList.toggle('is-scrollable', canScroll);
	el.classList.toggle('is-scrolled-end', !canScroll || atEnd);
}

function initTemplate3TableScroll() {
	if (!document.body.classList.contains('design-template-3')) {
		return;
	}

	const wrappers = document.querySelectorAll('.vm-article .article-wrapper, .htw-broadcasters__scroll');

	wrappers.forEach((el) => {
		updateScrollHint(el);
		el.addEventListener('scroll', () => updateScrollHint(el), { passive: true });
	});

	window.addEventListener('resize', () => {
		wrappers.forEach(updateScrollHint);
	});
}

$(function () {
	$('.swipe-for-more').each(function (i, el) {
		const $el = $(el);
		const $table = $el.prev().find('table');
		const $tableParent = $table.parent();

		if ($table.innerWidth() <= $tableParent.innerWidth()) {
			$el.addClass('hidden');
		}
	});

	initTemplate3TableScroll();
});
